module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "pv"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagev",
      "title": "v"
    }
  }, [_c('a', {
    attrs: {
      "id": "fm"
    }
  }), _vm._v("Food riots have been spreading in the North of Scotland to so great an extent that several parties of military have been despatched from Edinburgh. In some parts the country is described to be nearly in a state of insurrection.")])]), _vm._v(" "), _c('p', {
    staticClass: "right1"
  }, [_c('em', [_vm._v("Spectator")]), _vm._v(", 6 February 1847"), _c('a', {
    attrs: {
      "id": "pvi"
    }
  }), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagevi",
      "title": "vi"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16eacb0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm.vue
// module id = 66
// module chunks = 0